/** Прибирає class і style з усіх вузлів (DOMParser не виконує скрипти з рядка). */
export function stripClassesAndStylesFromPastedHtml(html: string): string {
  if (!html?.trim()) return html;

  const doc = new DOMParser().parseFromString(html, "text/html");

  // Забороняємо медіа-вставки у редакторі.
  const mediaSelectors = ["img", "video", "iframe", "source", "picture"];
  for (const selector of mediaSelectors) {
    doc.body.querySelectorAll(selector).forEach((node) => node.remove());
  }

  const chain: Element[] = [doc.body, ...Array.from(doc.body.getElementsByTagName("*"))];
  for (const el of chain) {
    el.removeAttribute("class");
    el.removeAttribute("style");
  }
  return doc.body.innerHTML;
}
